<template>
    <v-card
        block
        outlined
        elevation="0"
        :href="(item.pricelistFile) ? item.pricelistFile.url : null"
        target="_blank"
        rel="external"
        class="pricelist-card"
    >
        <div class="image">
            <v-img
                :src="item.thumbnail.url"
                v-if="item.thumbnail"
            ></v-img>
            <p v-else class="icon mb-0 text-center"><v-icon color="primary">fal fa-dollar-sign</v-icon></p>
        </div>

        <p class="text-center ma-3">
            {{ item.title }}
        </p>
        <v-card-actions class="align-center grey lighten-3">
            <v-btn text small color="primary" v-if="item.pricelistFile">Download</v-btn>
            <v-spacer></v-spacer>
            <v-btn icon color="primary" v-if="item.pricelistFile"><v-icon>fal fa-download</v-icon></v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: "PricelistCard",
    props: {
        item: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
